import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl, url }) => {
  const content = (
    <div className="proj-imgbx">
      <img src={imgUrl} alt={`${title} website preview`} loading="lazy" />
      <div className="proj-txtx">
        <h4>{title}</h4>
        <span>{description}</span>
        {url && <span className="project-visit">Visit website ↗</span>}
      </div>
    </div>
  );

  return (
    <Col xs={12} sm={6} lg={4} className="project-card-col">
      {url ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="project-card-shell"
          aria-label={`Visit the ${title} website`}
        >
          {content}
        </a>
      ) : (
        <article className="project-card-shell project-card-shell--static">
          {content}
        </article>
      )}
    </Col>
  );
};
